const RequestTracker =
	({ dispatch }) =>
	(next) =>
	(action) => {
		/*
        Pass all actions through by default.
    */

		const { type } = action;

		if (/(START|INIT)/.test(type)) {
			dispatch({ type: "REQUEST:TRACKER", direction: "outgoing", name: type.split("@")[0] });
		}

		if (/(SUCCESS|FAIL)/.test(type)) {
			// dispatch(TrackRequest('incoming', type.split('@')[0]));
			dispatch({ type: "REQUEST:TRACKER", direction: "incoming", name: type.split("@")[0] });
		}

		next(action);
	};

export default RequestTracker;
